import sha256 from 'crypto-js/sha256';

export function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function setTitle(title) {
    document.title = `${title ? `${title} | ` : ''}Blightbane, reference site for Dawncaster RPG`;
}

export async function getUserData() {
    let res = await fetch('./api/user');
    let json = await res.json();
    return json;
}

export function convertToRoman(num) {

    var remainingValue = num;
    var newRomanNumeral = "";

    var romanNumerals = [{
        numeral: "M",
        value: 1000
    }, {
        numeral: "CM",
        value: 900
    }, {
        numeral: "D",
        value: 500
    }, {
        numeral: "CD",
        value: 400
    }, {
        numeral: "C",
        value: 100
    }, {
        numeral: "XC",
        value: 90
    }, {
        numeral: "L",
        value: 50
    }, {
        numeral: "XL",
        value: 40
    }, {
        numeral: "X",
        value: 10
    }, {
        numeral: "IX",
        value: 9
    }, {
        numeral: "V",
        value: 5
    }, {
        numeral: "IV",
        value: 4
    }, {
        numeral: "I",
        value: 1
    }];

    for (var i = 0; i < 13; i++) {
        var j = Math.floor(remainingValue / romanNumerals[i].value); // j represents the number of times each character is needed
        while (remainingValue >= romanNumerals[i].value) {
            newRomanNumeral += romanNumerals[i].numeral.repeat(j); // Add 'x' Numerals to the string
            remainingValue -= (romanNumerals[i].value * j); // decrement the remaining value
        }
    }

    return newRomanNumeral;
}

export function convertName(name) {
    return (name || '').toLowerCase().indexOf('scion') !== -1 ? 'Trial of the Sunforge' : name;
}

export function isSunforge(name) {
    return (name || '').toLowerCase().indexOf('scion') !== -1;
}

export function trackPage() {
    gtag('config', 'G-5NRD9EMFGT', {
        page_location: window.location.href,
        page_path: window.location.pathname,
    });
}

export function friendlyURL(url) {
    return url.replace(/ /g, '_');
}

export function deFriendlyURL(url) {
    return url.replace(/_/g, ' ');
}

export function getNameFromURL(skipunderscore) {
    return decodeURI(decodeURIComponent(location.pathname.split('/')[2].replace(/\%20/g, ' ').replace(/_/g, skipunderscore ? '_':' ')));
}

export function loadURLParams(params) {
    (window.location.search || '').replace('?', '').split('&').forEach(p => {
        let arr = p.split('=');
        if (arr.length === 2)
            params[arr[0]] = arr[1];
    });
}

export function cardExpansion(card) {
    if (card.expansion === 3)
        return `<div class="bubble">Metamorphosis</div>`;
    if (card.expansion === 5)
        return `<div class="bubble">Infinitum</div>`;
    if (card.expansion === 6)
        return `<div class="bubble">Catalyst</div>`;
    if (card.expansion === 7)
        return `<div class="bubble">Eclypse</div>`;
    return '';
}

export function formatTimespan(date1, date2, summary) {

    var diff = date2.getTime() - date1.getTime();

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * (1000 * 60 * 60 * 24);

    var hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * (1000 * 60 * 60);

    var mins = Math.floor(diff / (1000 * 60));
    diff -= mins * (1000 * 60);

    var seconds = Math.floor(diff / (1000));
    diff -= seconds * (1000);

    if (!days && !hours && !mins && !seconds)
        return `< 1s`;

    if (summary) {
        if (days) {
            mins = null;
            seconds = null;
        } else if (hours) {
            mins = null;
            seconds = null;
        } else if (mins) {
            seconds = null;
        }
        return `${days ? `${days} day${days > 1 ? 's' : ''} ` : ''}${hours ? `${hours} hr${hours > 1 ? 's' : ''} ` : ''}${mins ? `${mins} minute${mins > 1 ? 's' : ''} ` : ''}${seconds ? `${seconds} second${seconds > 1 ? 's' : ''}` : ''}`;
    }

    return `${days ? `${days}d ` : ''}${hours ? `${hours}h ` : ''}${mins ? `${mins}m ` : ''}${seconds ? `${seconds}s` : ''}`;
}

export function timespanPercentage(date1, date2) {
    let diff = (new Date(date2)).getTime() - (new Date()).getTime();
    let totaldiff = (new Date(date2)).getTime() - (new Date(date1)).getTime();
    return (totaldiff - diff) / totaldiff * 100;
}

export function enumValue(obj,index){
    for(let prop in obj){
        if(obj[prop] === index)
            return prop;
    }
    return '';
}

export function imageToEmoji(img, list){
    if(img === 'crownOfUnity')
        return '🥇';
    if(img === 'cash-in')
        return '🤑';
    if(img === 'aura%20of%20purity' && !list)
        return '⚔️';
    return '';
}